import { useState } from "react";
import { Accordion, Icon } from "semantic-ui-react";
import { ICalculation } from "../../../models/calculation";
import { NPShiftsDisplay } from "../NPShiftsDisplay";

interface IProps {
    calculation: ICalculation;
}

export const CalcPropsNPShifts = ({ calculation }: IProps) => {
    const [open, setOpen] = useState(false);

    return (
        <Accordion id="accordion-CalcPropsNPShifts-a">
            <Accordion.Title id="accordionTitle-CalcPropsNPShifts-a" active={open} index={0} onClick={() => setOpen(!open)}>
                <Icon id="icon-CalcPropsNPShifts-a" name="dropdown" />
                NP Shifts
            </Accordion.Title>
            <Accordion.Content id="accordionContent-CalcPropsNPShifts-a" active={open}>
                <NPShiftsDisplay calculation={calculation} />
            </Accordion.Content>
        </Accordion>
    );
};
